
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources02 as ObiSources02Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-02.js';
 
 
 

 
 export const ObiSources02 = createComponent({
   react: React,
   tagName: 'obi-sources-02',
   elementClass: ObiSources02Element,
   events: {
     
   }
  });
 
 